module.exports = __webpack_public_path__ + "img/customerSel.b98a4df9.svg";